<template>
<div>


  <div   v-for="(data, index) in foundData.displayIds" @click= 'select($event, data)'  :class="{'page_list_row-selected': data.add_info.selected}" class="selectable page_list_row clearfloat">

  <div class="topic_info">
  <div class="labeled_name"  >  <a  target="_blank" v-bind ='{href: "https://vk.com/topic-"+data.tp_link}'   > <span> {{data.title}} </span> </a>   </div>
  <div   class="labeled"  > </div>
  <div   class="labeled selectable" > Сообщений: {{data.comments}} </div>
  <div   class="labeled" >    </div>
  </div>

  </div>

  <v-btn   v-if="loadMore" :loading="this.loadingMore"  block flat  color="#4A76A8"  @click="offSetChanger(foundData,'topics')"
  >
    показать еще {{loadMore}}
   </v-btn>

</div>
</template>




<script>
import axios from 'axios'
export default {
  props: ['foundData'],
 data: function(){
  return {
 loadingMore:false,
  }
},
computed:{
 loadMore(){

   if(this.foundData.displayIds.length < 20){
     this.offSetChanger(this.foundData,'topics')
     return this.foundData.foundIds.length - this.foundData.displayIds.length
   } else return this.foundData.foundIds.length - this.foundData.displayIds.length
 },
},
methods: {
  offSetChanger (data,type) {
    this.foundData.foundIds = this.foundData.foundIds.filter(item=> item.length)
    let pagesString =  data.foundIds.slice(data.offset, data.offset+20)
    data.offset = data.offset+pagesString.length
  if(pagesString.join(',') !== ''){
    this.loadingMore = true
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/get_description.php', {
         method: 'POST',
         data: {
           dataType: type,
           dataString:  pagesString.join(','),
           addInfo:{selected:data.selector}
         }
       })
       .then( response => {
         if(response.data){
           data.displayIds =   data.displayIds.concat(response.data)
           this.loadingMore = false
           }

       })
     } else {
         this.foundData.foundIds = this.foundData.foundIds.filter(item=> item.length)
       }
  },
  select: function(event,data){


    let classes = event.target.className.split(' ')

     if(classes.indexOf('selectable') !== -1){
       data.add_info.selected = !data.add_info.selected
        if(data.add_info.selected  ){

          this.foundData.selectedIds.push(data.tp_link)



        } else{



           this.foundData.selectedIds.splice(this.foundData.selectedIds.indexOf(data.tp_link),1)

        }

     //    event.target.className = 'page_list_row-selected'
   }


 },
}
}
</script>

<style>
.labeled_name a {
  text-decoration: none;
  color: #42648b;
}
.topic_info{
  padding-left:10px;
padding-top: 10px;
float: left;
  margin-bottom: 5px;
margin-right: 25px;
  overflow: hidden;
  width: 370px;
min-height: 80px;
}
.page_list_row .topic_info .labeled_name{
    margin-bottom: 5px;
  color: #42648b;
    font-weight: 700;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;

}
</style>
